// @flow strict

import * as React from 'react'
import styles from './PaidSectionWrapper.module.scss'
import { type PropsWithChildren } from '@mondough/public-web-components'
import cx from 'classnames'

const PaidSectionWrapper = ({
  className,
  contentClassName,
  children,
  id,
  mobileFullWidth,
  leaveLastChildOut,
}: PropsWithChildren<{
  className?: string,
  contentClassName?: string,
  id?: string,
  mobileFullWidth?: boolean,
  leaveLastChildOut?: boolean, // this is for when we need to _not_ wrap the lasst child in the content div
}>) => {
  const numChildren = React.Children.count(children)
  const childrenArray = React.Children.toArray(children)

  return (
    <section
      className={cx(
        styles.sectionBox,
        mobileFullWidth ? styles.fullWidthOnMobile : styles.defaultBoxWidths,
        className ? className : styles.defaultBox,
      )}
      id={id}
    >
      <div className={contentClassName || styles.content}>
        {leaveLastChildOut ? childrenArray.slice(0, numChildren - 1) : children}
      </div>
      {leaveLastChildOut ? childrenArray[numChildren - 1] : null}
    </section>
  )
}

export default PaidSectionWrapper
